import {
  FocusableItem,
  MenuDivider,
  MenuItem,
  SubMenu,
} from '@szhsin/react-menu';
import { CSSProperties } from 'react';
import { Checkbox, Flex, Input } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { IContextMenuItem } from '../../../helpers/contextMenu/types';

const commonClassName = 'context-menu';

const NormalMenu = ({
  title,
  disabled,
  Icon,
  action,
  checkbox,
  checked,
}: IContextMenuItem) => (
  <MenuItem
    style={{
      ...styles.menu,
      pointerEvents: disabled ? 'none' : 'all',
    }}
    onClick={({ syntheticEvent }) => {
      syntheticEvent.preventDefault();
      syntheticEvent.stopPropagation();
      // e.preventDefault();
      // console.log('clicked', action);
      if (action) action();
    }}
    className={commonClassName}
    disabled={disabled}
  >
    {Icon && <Icon className={commonClassName} />}
    {checkbox && (
      <Checkbox
        className={commonClassName}
        isChecked={checked}
        onChange={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        // onClick={action}
      />
    )}
    <div style={styles.menuTitle} className={commonClassName}>
      {title}
    </div>
  </MenuItem>
);

const SubMenuTitle = ({ title }: { title: string }) => (
  <div style={styles.menuTitle} className={commonClassName}>
    {title}
  </div>
);

const renderSubMenuTitle = ({
  title,
  Icon,
  checkbox,
  checked,
  action,
  onClose,
}: Pick<
  IContextMenuItem,
  'title' | 'Icon' | 'checkbox' | 'checked' | 'action'
> & {
  onClose: () => void;
}) => {
  return (
    <div style={styles.subMenuTitleContainer} className={commonClassName}>
      <Flex
        align="center"
        className={commonClassName}
        onClick={(e) => {
          if (action) {
            e.preventDefault();
            e.stopPropagation();
            action();
            onClose();
          }
        }}
      >
        {Icon && <Icon className={commonClassName} />}
        {checkbox && (
          <Checkbox
            className={commonClassName}
            isChecked={checked}
            defaultChecked
            onChange={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          />
        )}
        <SubMenuTitle title={title} />
      </Flex>
    </div>
  );
};

const SubMenuView = ({
  menu: { disabled, nestedMenus, ...titleProps },
  background,
  onClose,
}: {
  menu: IContextMenuItem;
  background: string;
  onClose: () => void;
}) => {
  return (
    <SubMenu
      label={renderSubMenuTitle({
        ...titleProps,
        onClose,
      })}
      overflow={'auto'}
      disabled={disabled}
      menuStyle={{
        padding: 0,
        background: background,
        color: 'inherit',
      }}
      className={commonClassName}
    >
      {nestedMenus && (
        <MenuView
          menuSets={nestedMenus}
          background={background}
          onClose={onClose}
        />
      )}
    </SubMenu>
  );
};

const MenuDividerView = () => <MenuDivider style={styles.menuDivider} />;

interface MenuViewProps {
  menuSets: IContextMenuItem[][];
  background: string;
  onClose: () => void;
}
export const MenuView = ({ menuSets, background, onClose }: MenuViewProps) => {
  let VisibleMenus: JSX.Element[] = [];

  menuSets.forEach((menus, index) => {
    menus.forEach((menu) => {
      if (menu.nestedMenus?.length)
        VisibleMenus.push(
          <SubMenuView
            menu={menu}
            key={menu.title}
            background={background}
            onClose={onClose}
          />
        );
      else VisibleMenus.push(<NormalMenu {...menu} key={menu.title} />);
    });

    if (menuSets.length - 1 > index)
      VisibleMenus.push(<MenuDividerView key={Math.random()} />);
  });

  return <>{VisibleMenus}</>;
};

interface MenuSearchInputProps {
  value: string;
  onChange: (text: string) => void;
}
export const MenuSearchInput: React.FC<MenuSearchInputProps> = ({
  value,
  onChange,
}) => {
  return (
    <FocusableItem>
      {({ ref }) => (
        <Input
          ref={ref}
          type="search"
          placeholder="Search"
          size="sm"
          variant="outline"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={commonClassName}
          onKeyDown={(e) => {
            if (e.key === 'Backspace') {
              ref.current.focus();
            }
          }}
          // autoFocus={true}
        />
      )}
    </FocusableItem>
  );
};

const styles = {
  menuTitle: {
    paddingLeft: '10px',
    textTransform: 'capitalize',
    fontFamily: 'Lato',
    pointerEvents: 'none',
  } as CSSProperties,
  menu: {
    paddingLeft: '15px',
    minWidth: '300px',
  } as CSSProperties,
  subMenuTitleContainer: {
    marginLeft: -10,
    minWidth: '246px',
  },
  menuDivider: {
    margin: 0,
  },
};
